module.exports = __webpack_public_path__ + "img/__icon_FIRANKA.e357442c.svg";